import { render, staticRenderFns } from "./appIndex.vue?vue&type=template&id=94f89b82&scoped=true&"
import script from "./appIndex.vue?vue&type=script&lang=js&"
export * from "./appIndex.vue?vue&type=script&lang=js&"
import style0 from "./appIndex.vue?vue&type=style&index=0&id=94f89b82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f89b82",
  null
  
)

export default component.exports